import { useLocation } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { SupportRequestType } from 'features/offline-reports/support-requests/components/support-requests-modals/types';
import { getFeatureFlags } from 'core/flow-control';
import { useSelector } from 'react-redux';
import {
    selectFilteredSupportRequests,
    selectSupportSelectedRequest,
} from 'store/offline-reports/selectors/offline-reports-selectors-factory';
import { useOfflineReportsActions } from 'store/offline-reports/use-offline-reports-actions';
import { useOpenSupportRequest } from 'features/offline-reports/support-requests/components/support-requests-modals/support-modal-manager';

export const REQUEST_TYPE_QUERY = 'type';
export const REQUEST_ID_QUERY = 'requestId';

const useSupportSearchQuery = () => {
    const { search } = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);

    const requestType = useMemo(
        () => params.get(REQUEST_TYPE_QUERY) as SupportRequestType,
        [params],
    );
    const requestId = useMemo(() => params.get(REQUEST_ID_QUERY) as SupportRequestType, [params]);

    return {
        requestType,
        requestId,
    };
};

export const useOpenSupportByQueryParam = () => {
    const { enable_support_diff_url_ff } = getFeatureFlags();
    const { requestType, requestId } = useSupportSearchQuery();
    const selectedRequest = useSelector(selectSupportSelectedRequest);
    const filteredSupportRequests = useSelector(selectFilteredSupportRequests);
    const { setSupportSelectedRequest } = useOfflineReportsActions();
    const { openSupportRequest } = useOpenSupportRequest();

    useEffect(() => {
        if (!enable_support_diff_url_ff || !requestType) return;

        if (requestType === 'info') {
            const requestExists = requestId && filteredSupportRequests?.length && !selectedRequest;

            if (requestExists) {
                const request = filteredSupportRequests.find(({ id }) => requestId === id);

                setSupportSelectedRequest(request);

                request && openSupportRequest({ flowType: requestType, props: { requestId } });
            }
            return;
        }

        openSupportRequest({ flowType: requestType });
    }, [
        enable_support_diff_url_ff,
        filteredSupportRequests,
        openSupportRequest,
        requestId,
        requestType,
        selectedRequest,
        setSupportSelectedRequest,
    ]);
};
